/*! facett renewal — 下層 Gift hero
 * PC: 静的3枚／SP: CSS自動フェード（タッチスワイプなし）
 * iOS: アドレスバーによる resize では再初期化しない
 * スクロール中も自動切替タイマーは進行する
 */
(function () {
  var MQ_SP = '(max-width: 767px)';
  var lastSp = null;

  function isSp() {
    return window.matchMedia(MQ_SP).matches;
  }

  function sectionAppearance(root) {
    return root.getAttribute('data-facett-gift-hero-appearance') === 'light' ? 'light' : 'dark';
  }

  function appearanceFromSlide(slide) {
    if (!slide) return 'dark';
    var value = slide.getAttribute('data-facett-appearance');
    return value === 'light' ? 'light' : 'dark';
  }

  function applyAppearance(root, value) {
    var appearance = value === 'light' ? 'light' : 'dark';
    root.classList.toggle('facett-gift-hero--light', appearance === 'light');
    root.classList.toggle('facett-gift-hero--dark', appearance === 'dark');
    root.classList.toggle('facett-gift-hero--sp-light', appearance === 'light');
    root.classList.toggle('facett-gift-hero--sp-dark', appearance === 'dark');
    root.setAttribute('data-facett-sp-appearance', appearance);
  }

  function syncAppearanceFromSlide(root, slide) {
    if (!root) return;
    if (!isSp()) {
      applyAppearance(root, sectionAppearance(root));
      return;
    }
    applyAppearance(root, appearanceFromSlide(slide || root.querySelector('.swiper-slide')));
  }

  function destroyAutoFade(root) {
    if (!root || !root._facettGiftHeroFade) return;
    var ctrl = root._facettGiftHeroFade;
    ctrl.dead = true;
    if (ctrl.timer) {
      window.clearInterval(ctrl.timer);
    }
    if (ctrl.el) {
      ctrl.el.classList.remove('facett-autofade');
      ctrl.el.style.removeProperty('--facett-autofade-speed');
      ctrl.el.querySelectorAll('.swiper-slide').forEach(function (slide) {
        slide.classList.remove('is-autofade-active');
      });
    }
    root._facettGiftHeroFade = null;
  }

  function initAutoFade(root, el, speed, delay) {
    var slides = Array.prototype.slice.call(el.querySelectorAll('.swiper-slide'));
    if (slides.length <= 1) return null;

    el.classList.add('facett-autofade');
    el.style.setProperty('--facett-autofade-speed', speed + 'ms');
    el.style.touchAction = 'pan-y';

    var index = 0;
    slides.forEach(function (slide, i) {
      slide.classList.toggle('is-autofade-active', i === 0);
    });
    syncAppearanceFromSlide(root, slides[0]);

    var ctrl = { el: el, timer: null, dead: false };
    ctrl.timer = window.setInterval(function () {
      if (ctrl.dead) return;
      if (document.hidden) return;
      slides[index].classList.remove('is-autofade-active');
      index = (index + 1) % slides.length;
      slides[index].classList.add('is-autofade-active');
      syncAppearanceFromSlide(root, slides[index]);
    }, delay);

    return ctrl;
  }

  function destroyHero(root) {
    if (!root) return;
    destroyAutoFade(root);
    root.dataset.facettGiftHeroReady = '';
    applyAppearance(root, sectionAppearance(root));
  }

  function initHero(root) {
    if (!root) return;
    var el = root.querySelector('[data-facett-gift-hero-swiper]');
    if (!el) return;

    /* 既に SP フェード稼働中なら触らない（resize 連打対策） */
    if (isSp() && root._facettGiftHeroFade && root.dataset.facettGiftHeroReady === '1') {
      return;
    }

    destroyHero(root);

    if (!isSp()) {
      applyAppearance(root, sectionAppearance(root));
      root.dataset.facettGiftHeroReady = '1';
      return;
    }

    var speed = parseInt(root.dataset.speed, 10) || 800;
    var delay = parseInt(root.dataset.delay, 10) || 5000;
    var slides = el.querySelectorAll('.swiper-slide');
    if (slides.length <= 1) {
      root.classList.add('facett-gift-hero--single');
      syncAppearanceFromSlide(root, slides[0] || null);
      root.dataset.facettGiftHeroReady = '1';
      return;
    }

    root.classList.remove('facett-gift-hero--single');
    root._facettGiftHeroFade = initAutoFade(root, el, speed, delay);
    root.dataset.facettGiftHeroReady = '1';
  }

  function syncAll() {
    document.querySelectorAll('[data-facett-gift-hero]').forEach(function (root) {
      initHero(root);
    });
  }

  function boot(force) {
    var roots = document.querySelectorAll('[data-facett-gift-hero]');
    if (!roots.length) return;
    var sp = isSp();
    if (!force && lastSp !== null && lastSp === sp) {
      /* SP↔PC の境界を跨いでいない → 再初期化しない */
      return;
    }
    lastSp = sp;
    if (force) {
      roots.forEach(destroyHero);
    }
    syncAll();
  }

  var resizeTimer = null;
  function onResize() {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () {
      boot(false);
    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(true);
    });
  } else {
    boot(true);
  }

  window.addEventListener('resize', onResize);

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector('[data-facett-gift-hero]');
    if (root) {
      destroyHero(root);
      lastSp = null;
      boot(true);
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target && event.target.querySelector('[data-facett-gift-hero]');
    if (root) {
      destroyHero(root);
    }
  });
})();
